import list from 'src/modules/position/list/positionListReducers';
import form from 'src/modules/position/form/positionFormReducers';
import view from 'src/modules/position/view/positionViewReducers';
import destroy from 'src/modules/position/destroy/positionDestroyReducers';
import importerReducer from 'src/modules/position/importer/positionImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
